import {gql} from "@irati/utils/gql"

const fragment = gql`
  fragment MarketingProfile on MarketingProfile {
    uuid
    signature
    settings {
      emailSubscribed
      pushSubscribed
      unsubscribedEmail
      unsubscribedPush
      wellnessLiveNotifications {
        mediaId
        expiresAt
      }
    }
  }
`

export default fragment
